<template>
    <div>
        <create-task-headline
            title="Skapa ny select"
            help-text="En select är ett val där man får välja mellan ett av flera alternativ för att klarmarkera uppgiften."
        />
        <form class="flex flex-col" @submit.prevent="addOption">
            <text-input
                v-model="body"
                label="Uppgift"
                name="body"
                :autofocus="true"
            />

            <div class="flex items-center">
                <text-input
                    v-model="newOption"
                    label="Nytt val"
                    name="new_option"
                    class="flex-grow mr-lg mb-0"
                />

                <button
                    type="submit"
                    class="ml-auto btn btn-md is-primary"
                >
                    Lägg till val
                </button>
            </div>

            <add-dependency
                v-model="task_template_parent_id"
                class="mt-lg"
                :task-list-template="taskListTemplate"
            />
        </form>

        <ul class="mt-md list-reset">
            <li
                v-for="(option, key) in options"
                :key="key"
                class="mb-sm"
            >
                <font-awesome-icon
                    :icon="['fal', 'times']"
                    class="text-danger cursor-pointer mr-sm"
                    @click="removeOption(option)"
                />

                {{ option }}
            </li>
        </ul>

        <div class="button-group">
            <button
                type="button"
                class="btn btn-md is-ghost"
                @click="$emit('cancel')"
            >
                Avbryt
            </button>

            <checkbox-input
                v-model="createMoreOfThisType"
                class="my-md lg:my-0"
                value="1"
            >
                Skapa fler av denna typ
            </checkbox-input>

            <button
                type="button"
                class="btn btn-md is-primary"
                @click="create"
            >
                Skapa
            </button>
        </div>
    </div>
</template>
<script>
    import BaseCreate from './BaseCreate';
    import CreateTaskHeadline from './Headline';
    import AddDependency from './AddDependency';

    export default {
        components: {
            CreateTaskHeadline,
            AddDependency,
        },
        extends: BaseCreate,
        props: {
            taskListTemplate: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                body: '',
                options: {},
                newOption: '',
                type: 'select',
            };
        },
        computed: {
            extraData() {
                return {
                    options: this.options,
                };
            },
        },
        methods: {
            addOption() {
                this.options[this.newOption] = this.newOption;
                this.newOption = '';

                document.getElementsByName('new_option')[0].focus();
            },
            removeOption(option) {
                Vue.delete(this.options, option);
            },
        },
    };
</script>